export default {
  singleLabel: "Contact",
  storeNamespace: 'company_contact',
  authFeature: 'company-contact',
  listRouteName: "CompanyContactList",
  newRouteName: "CompanyContactNew",
  editRouteName: "CompanyContactEdit",
  detailRouteName: "CompanyContactDetail",
  useNewModal: true,
  useEditModal: true,
  formComponentName: 'CompanyContactForm',
  hideActionCsvButton: true,
  hideActionPdfButton: true,
  titleField: 'fullname',
  sortBy: 'firstname',
  showExtendedFilters: true,
  fields: [{
      name: 'fullname',
      label: "Nom complet",
      type: 'text',
      inForm: false,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: false,
      formatter: (context, value, item) => item && item.firstname && item.lastname ? item.firstname + ' ' + item.lastname : null
    },
    {
      name: 'firstname',
      label: "Prénom",
      type: 'text',
      inForm: true,
      required: true,
      inList: false,
      inDetail: true,
    },
    {
      name: 'lastname',
      label: "Nom",
      type: 'text',
      inForm: true,
      required: true,
      inList: false,
      inDetail: true,
    },
    {
      name: 'company_id',
      label: "Entreprise",
      type: 'select',
      inForm: true,
      required: true,
      inList: false,
      sortable: true,
      inDetail: false,
    },
    {
      name: 'company',
      label: "Entreprise",
      type: 'select',
      inForm: false,
      inList: true,
      sortable: true,
      extendedFilter: true,
      filterIn: true,
      inDetail: true,
      detailLink: 'CompanyDetail',
      formatter: (context, value) => value && value.name ? value.name : null
    },
    {
      name: 'email',
      label: "Email",
      type: 'email',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
      link: (context, value) => value ? 'mailto:' + value : null,
      isHtml: true,
      formatter: (context, value) => value ? '<a href="mailto:' + value + '">' + value + '</a>' : null
    },
    {
      name: 'phone_number',
      label: "Téléphone",
      type: 'tel',
      inForm: true,
      required: false,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
      link: (context, value) => value ? 'tel:' + value : null,
      isHtml: true,
      formatter: (context, value) => value ? '<a href="tel:' + value + '">' + value + '</a>' : null
    },
    {
      name: 'cellphone_number',
      label: "Téléphone portable",
      type: 'tel',
      inForm: true,
      required: false,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
      link: (context, value) => value ? 'tel:' + value : null,
      isHtml: true,
      formatter: (context, value) => value ? '<a href="tel:' + value + '">' + value + '</a>' : null
    },
    {
      name: 'function',
      label: "Fonction",
      type: 'text',
      inForm: true,
      required: false,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: false,
      inPdfExport: false,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: false,
      inPdfExport: false,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/CompanyContact/config.js